export type WishlistSection = "products" | "brands" | "categories";

const WISHLIST_SECTION_REQUEST_KEY = "kitanego-wishlist-section-request";
let pendingWishlistSection: WishlistSection | "" = "";

function isWishlistSection(value: string | null): value is WishlistSection {
  return value === "products" || value === "brands" || value === "categories";
}

export function requestWishlistSection(section: WishlistSection): void {
  pendingWishlistSection = section;
  try {
    window.sessionStorage.setItem(WISHLIST_SECTION_REQUEST_KEY, section);
  } catch {
    // The in-memory request still carries the section for this navigation.
  }
}

export function takeRequestedWishlistSection(): WishlistSection {
  let section: string | null = pendingWishlistSection;
  pendingWishlistSection = "";
  try {
    section ||= window.sessionStorage.getItem(WISHLIST_SECTION_REQUEST_KEY);
    window.sessionStorage.removeItem(WISHLIST_SECTION_REQUEST_KEY);
  } catch {
    // Session storage is optional; use the in-memory request when unavailable.
  }
  return isWishlistSection(section) ? section : "products";
}
